import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SHOW_MODAL_ON_ERROR } from '../../interceptors/interceptor.token';
import { LIB_CONFIG, LibConfig } from '../../lib.config';
import { Ort } from '../../model/ort';
import { checkParams } from '../../shared/utils/check-params.util';
import { SucheError } from './suche-error';

export enum OrtServiceParams {
  SUCHWORT = 'suchwort',
  LATITUDE = 'lat',
  LONGITUDE = 'lon'
}

@Injectable({
  providedIn: 'root'
})
export class OrtClient {
  private readonly libConfig = inject<LibConfig>(LIB_CONFIG);
  private readonly http = inject(HttpClient);

  public static SERVER_ERROR = 'SUCHE_ORT_SERVER_ERROR';

  public getOrtBySuchwort(suchString: string): Observable<Array<Ort>> {
    let urlParams = new HttpParams();

    if (suchString) {
      urlParams = urlParams.set(OrtServiceParams.SUCHWORT, suchString);
    }
    return this.getOrteBy(urlParams);
  }

  public getOrtByPlz(plz: string): Observable<Array<Ort>> {
    let urlParams = new HttpParams();
    if (plz) {
      urlParams = urlParams.set(OrtServiceParams.SUCHWORT, plz);
    }
    return this.getOrteBy(urlParams);
  }

  public getOrtByCoords(latitude: number, longitude: number): Observable<Ort> {
    const urlParams = new HttpParams()
      .set(OrtServiceParams.LATITUDE, latitude)
      .set(OrtServiceParams.LONGITUDE, longitude);

    return this.http
      .get<Ort>(`${this.libConfig.backendHost}/pc/v1/orte/coords`, {
        params: checkParams(urlParams),
        responseType: 'json',
        context: new HttpContext().set(SHOW_MODAL_ON_ERROR, true)
      })
      .pipe(
        catchError((error) => {
          throw new SucheError('Fehler beim Laden der Ortes anhand der Koordinaten', error);
        })
      );
  }

  private getOrteBy(urlParams: HttpParams): Observable<Array<Ort>> {
    return this.http
      .get<Array<Ort>>(`${this.libConfig.backendHost}/pc/v1/orte`, {
        params: checkParams(urlParams),
        responseType: 'json',
        context: new HttpContext().set(SHOW_MODAL_ON_ERROR, true)
      })
      .pipe(
        catchError((error) => {
          throw new SucheError('Fehler beim Laden der Ortes', error);
        })
      );
  }
}
